import * as React from 'react';
import * as PXBColors from '@brightlayer-ui/colors';
import { StatusLabel } from '../StatusLabel';
import { useLanguageLocale } from '../../hooks/language-locale-hooks';

export const AcknowledgedStatusLabel: React.FC = () => {
    const { t } = useLanguageLocale();

    return (
        <StatusLabel
            status={t('DASHBOARD.TIMELINE_DETAILS.ACKNOWLEDGED')}
            foregroundColor={PXBColors.blue[50]}
            backgroundColor={PXBColors.blue[600]}
            testId="acknowledged-status-label"
        />
    );
};
